import { render, staticRenderFns } from "./calcEmpty.vue?vue&type=template&id=9faa6ca4"
import script from "./calcEmpty.vue?vue&type=script&lang=js"
export * from "./calcEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports